import React from 'react';
import {Link} from 'react-router-dom';


interface Default {
    link: string
    title: string,
    className: any,
}

interface RoutesProps {
    className?: any,
    wrapperClassName?:string,
    routes: Array<Default>
}


const MultiRote: React.FC<RoutesProps> = (props: RoutesProps) => {

    const routes = props.routes;
    const className = props.className;
    const wrapperClassName = props.wrapperClassName || 'pt-5 pb-5';


    return (<React.Fragment>
        <div className={wrapperClassName}>
            <div className={`multiRoutes ${className}`}>
                {routes.map(r => {
                    return <Link to={r.link}
                                 className={`multiRoute ${r.className}`}
                                 key={r.link}>
                            <span>{r.title}</span>
                            <div className="indicator"/>
                       </Link>
                })}
            </div>
        </div>
    </React.Fragment>);
};


export default MultiRote;

